import axios from "axios/index";
import { API } from "../utilities/api.config";
import { formatPayload } from "../utilities/format";

function login(loginInfo) {
  return (dispatch) => {
    dispatch({ type: "USER_AUTH_REQUESTED" });
    axios
      .post(API.AUTH, formatPayload(loginInfo))
      .then((response) => {
        localStorage.setItem("wbiAuthToken", response.data.token);
        localStorage.setItem("wbiNavBarOpened", "true");
        dispatch({
          type: "USER_AUTH_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "USER_AUTH_FAIL",
          payload: error,
        });
      });
  };
}

function signUp(signUpInfo) {
  return (dispatch) => {
    dispatch({ type: "USER_CREATE_REQUESTED" });
    return axios
      .post(API.CREATE_USER, formatPayload(signUpInfo))
      .then((response) => {
        localStorage.setItem("wbiAuthToken", response.data.token);
        localStorage.setItem("wbiNavBarOpened", "true");
        dispatch({
          type: "USER_CREATE_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "USER_CREATE_FAIL",
          payload: error,
        });
        throw error;
      });
  };
}

function createAdvisorProfile(userProfile) {
  return (dispatch) => {
    axios
      .patch(API.UPDATE_USER, userProfile, {
        headers: { Authorization: `${localStorage.getItem("wbiAuthToken")}` },
      })
      .then((response) => {
        dispatch({
          type: "USER_CREATE_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "USER_CREATE_FAIL",
          payload: error,
        });
      });
  };
}

function saveUserProfile(userProfile) {
  return (dispatch) => {
    axios
      .patch(API.UPDATE_USER, userProfile, {
        headers: { Authorization: `${localStorage.getItem("wbiAuthToken")}` },
      })
      .then((response) => {
        dispatch({
          type: "USER_UPDATE_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "USER_UPDATE_FAIL",
          payload: error,
        });
      });
  };
}

function updateAdvisorConfig(payload) {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_ADVISOR_CONFIG",
      payload: payload,
    });
  };
}

function updateJiraUser(payload) {
  return (dispatch) => {
    dispatch({
      type: "CREATE_JIRA_USER",
      payload: payload,
    });
  };
}

function saveAdvisorSetting(payload) {
  return (dispatch) => {
    dispatch({
      type: "ADVISOR_UPDATE_REQUESTED",
      payload: payload,
    });
    axios
      .patch(API.UPDATE_USER_SETTINGS, payload, {
        headers: { Authorization: `${localStorage.getItem("wbiAuthToken")}` },
      })
      .then((response) => {
        dispatch({
          type: "ADVISOR_UPDATE_SUCCESS",
          payload: payload,
        });
      })
      .catch((error) => {
        dispatch({
          type: "ADVISOR_UPDATE_FAIL",
          payload: error,
        });
      });
  };
}

function loadUserApplicationState() {
  return (dispatch) => {
    const token = localStorage.getItem("wbiAuthToken");
    if (!token) {
      dispatch({
        type: "LOAD_USER_APPLICATION_STATE_FAIL",
        payload: {},
      });
      return;
    }

    dispatch({ type: "LOAD_USER_APPLICATION_STATE_REQUESTED" });
    axios
      .get(API.GET_USER_APPLICATION_STATE, {
        headers: { Authorization: token },
      })
      .then((response) => {
        dispatch({
          type: "LOAD_USER_APPLICATION_STATE_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "LOAD_USER_APPLICATION_STATE_FAIL",
          payload: error,
        });
        dispatch(logout());
      });
  };
}

function logout(history) {
  return (dispatch) => {
    axios.post(API.LOGOUT)
    .then(() => {
      if (history) {
        history.push("/");
      }
      if (window && window.localStorage) {
        localStorage.clear();
      }
      dispatch({
        type: "LOGOUT",
      });
    });
  };
}

function videoWatched() {
  return (dispatch) => {
    dispatch({
      type: "VIDEO_WATCHED_REQUESTED",
    });

    axios
      .patch(
        API.VIDEO_WATCHED,
        { video_watched: true },
        {
          headers: { Authorization: `${localStorage.getItem("wbiAuthToken")}` },
        }
      )
      .then((response) => {
        dispatch({
          type: "VIDEO_WATCHED_SUCCESS",
        });
      })
      .catch((error) => {
        dispatch({
          type: "VIDEO_WATCHED_FAIL",
          payload: error,
        });
        if (error.response.status === 401) {
          dispatch({
            type: "LOGOUT",
          });
        }
      });
  };
}

function acknowledgeTerms(acknowledgement) {
  return (dispatch) => {
    dispatch({
      type: "ACKNOWLEDGE_TERMS_REQUESTED",
    });

    axios
      .patch(
        API.ACKNOWLEDGE_TERMS,
        { acknowledgement },
        {
          headers: { Authorization: `${localStorage.getItem("wbiAuthToken")}` },
        }
      )
      .then((response) => {
        dispatch({
          type: "ACKNOWLEDGE_TERMS_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "ACKNOWLEDGE_TERMS_FAIL",
          payload: error,
        });
        if (error.response.status === 401) {
          dispatch({
            type: "LOGOUT",
          });
        }
      });
  };
}

// Created by Kate
// Function to get all the users
function getAllUsers() {
  return (dispatch) => {
    dispatch({
      type: "USERS_FETCH_REQUESTED",
    });
    axios
      .get(API.GET_ALL_USERS, {
        headers: { Authorization: `${localStorage.getItem("wbiAuthToken")}` },
      })
      .then((response) => {
        dispatch({
          type: "USERS_FETCH_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "USERS_FETCH_FAIL",
          payload: error,
        });
        if (error.response.status === 401) {
          dispatch({
            type: "LOGOUT",
          });
        }
      });
  };
}

// Created by Kate
// Function to get the user by ID
function getUserById(id) {
  return (dispatch) => {
    dispatch({
      type: "USER_FETCH_REQUESTED",
    });
    axios
      .get(`${API.GET_USER_BY_ID}/${id}`, {
        headers: { Authorization: localStorage.getItem("wbiAuthToken") },
      })
      .then((response) => {
        dispatch({
          type: "USER_FETCH_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "USER_FETCH_FAIL",
          payload: error,
        });
        if (error.response.status === 401) {
          dispatch({
            type: "LOGOUT",
          });
        }
      });
  };
}

function getUserByToken(token) {
  return (dispatch) => {
    dispatch({ type: "TOKEN_AUTH_REQUESTED" });
    return axios
      .get(`${API.GET_USER_BY_TOKEN}/${token}`)
      .then((response) => {
        localStorage.setItem("wbiAuthToken", response.data.token);
        localStorage.setItem("wbiNavBarOpened", "true");
        dispatch({
          type: "TOKEN_AUTH_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "TOKEN_AUTH_FAIL",
          payload: error,
        });
        throw error;
      });
  };
}

// Created by Kate
// Function to update the user
function updateUserById(id, data) {
  return (dispatch) => {
    dispatch({
      type: "USER_UPDATE_REQUESTED",
    });
    axios
      .patch(`${API.UPDATE_USER_BY_ID}/${id}`, data, {
        headers: { Authorization: localStorage.getItem("wbiAuthToken") },
      })
      .then((response) => {
        dispatch({
          type: "USER_UPDATE_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "USER_UPDATE_FAIL",
          payload: error,
        });
        if (error.response.status === 401) {
          dispatch({
            type: "LOGOUT",
          });
        }
      });
  };
}

function requestPasswordReset(email) {
  return (dispatch) => {
    dispatch({
      type: "USER_REQUEST_PW_RESET_REQUESTED",
    });
    return axios
      .post(API.REQUEST_PASSWORD_RESET, { email })
      .then((response) => {
        const payload = response.data;
        dispatch({
          type: "USER_REQUEST_PW_RESET_SUCCESS",
          payload,
        });
        return payload;
      })
      .catch((error) => {
        dispatch({
          type: "USER_REQUEST_PW_RESET_FAIL",
          payload: error,
        });
      });
  };
}

function resetPassword(payload) {
  return (dispatch) => {
    dispatch({
      type: "USER_PASSWORD_RESET_REQUESTED",
    });
    return axios
      .post(API.RESET_PASSWORD, payload)
      .then((response) => {
        const payload = response.data;
        dispatch({
          type: "USER_PASSWORD_RESET_SUCCESS",
          payload,
        });
        return payload;
      })
      .catch((error) => {
        dispatch({
          type: "USER_PASSWORD_RESET_FAIL",
          payload: error,
        });
      });
  };
}

function getBrokerDealers(searchTerm, getAll = false, getVerified = true) {
  return (dispatch) => {
    dispatch({
      type: "BROKER_DEALERS_REQUESTED",
    });
    return axios
      .get(API.GET_BROKER_DEALERS, {
        params: {
          search: searchTerm,
          getAll: getAll,
          getVerified: getVerified,
        },
      })
      .then((response) => {
        const payload = response.data;
        dispatch({
          type: "BROKER_DEALERS_SUCCESS",
          payload,
        });
        return payload;
      })
      .catch((error) => {
        dispatch({
          type: "BROKER_DEALERS_FAIL",
          payload: error,
        });
      });
  };
}

function clearApiMessage() {
  return (dispatch) => {
    dispatch({
      type: "CLEAR_USER_ERROR_MESSAGE",
    });
  };
}

export const userAction = {
  login,
  signUp,
  loadUserApplicationState,
  saveUserProfile,
  logout,
  updateJiraUser,
  updateAdvisorConfig,
  saveAdvisorSetting,
  videoWatched,
  acknowledgeTerms,
  getAllUsers,
  getUserById,
  updateUserById,
  getUserByToken,
  createAdvisorProfile,
  requestPasswordReset,
  resetPassword,
  getBrokerDealers,
  clearApiMessage,
};

export default userAction;



// WEBPACK FOOTER //
// ./src/actions/user.action.js